(() => {
  const clean = (value) => String(value || "").replace(/\s+/g, " ").trim().slice(0, 80);

  const track = (action, label) => {
    const eventName = clean(action);
    if (!eventName) return;

    if (typeof window.clarity === "function") {
      window.clarity("event", eventName);
      if (label) window.clarity("set", "last_click_label", clean(label));
    }

    if (typeof window.hj === "function") {
      window.hj("event", eventName);
    }
  };

  document.addEventListener("click", (event) => {
    const target = event.target.closest("[data-track]");
    if (!target) return;
    const label = target.getAttribute("data-track-label") || target.textContent;
    track(target.getAttribute("data-track"), label);
  });

  document.addEventListener("toggle", (event) => {
    const target = event.target;
    if (!target.matches("[data-track]")) return;
    const state = target.open ? "open" : "close";
    track(`${target.getAttribute("data-track")}-${state}`, target.getAttribute("data-track-label"));
  }, true);

  const moveProjectPaymentBeforeFaq = () => {
    const faqSection = document.querySelector('[id*="__project_faq"]');
    if (!faqSection) return;
    if (document.querySelector('[id*="__payment_info"]')) return;

    const paymentSection = Array.from(document.querySelectorAll(".project-section--split")).find((section) => {
      const eyebrow = section.querySelector(".eyebrow");
      return clean(eyebrow && eyebrow.textContent) === "付款方式";
    });
    if (!paymentSection || paymentSection.dataset.paymentMoved === "true") return;

    const wrapper = document.createElement("div");
    wrapper.className = "shopify-section";
    wrapper.setAttribute("data-payment-moved-wrapper", "true");
    wrapper.innerHTML = '<section class="section section--soft"><div class="section-inner"></div></section>';

    paymentSection.dataset.paymentMoved = "true";
    paymentSection.classList.add("project-section--payment-moved");
    wrapper.querySelector(".section-inner").appendChild(paymentSection);
    faqSection.parentNode.insertBefore(wrapper, faqSection);
  };

  const initProjectCityFilters = () => {
    const sections = document.querySelectorAll(".content-cards-section, .project-city-cards-section");

    sections.forEach((section) => {
      const cards = Array.from(section.querySelectorAll("[data-city-card]"));
      if (cards.length <= 6) return;

      let filter = section.querySelector("[data-city-filter]");
      const grid = section.querySelector(".grid");
      if (!grid) return;

      if (!filter) {
        filter = document.createElement("div");
        filter.className = "city-filter";
        filter.setAttribute("data-city-filter", "auto");
        filter.setAttribute("aria-label", "依城市篩選項目");
        filter.innerHTML = `
          <button class="city-filter__button is-active" type="button" data-city-filter-button="中山" data-track="project-city-filter" data-track-label="中山" aria-pressed="true">
            <span class="city-filter__name">中山</span>
            <span class="city-filter__meta">查看項目</span>
          </button>
          <button class="city-filter__button" type="button" data-city-filter-button="珠海" data-track="project-city-filter" data-track-label="珠海" aria-pressed="false">
            <span class="city-filter__name">珠海</span>
            <span class="city-filter__meta">查看項目</span>
          </button>
        `;
        grid.parentNode.insertBefore(filter, grid);
      }

      if (filter.dataset.cityFilterReady === "true") return;
      filter.dataset.cityFilterReady = "true";
      filter.classList.add("is-ready");

      const buttons = Array.from(filter.querySelectorAll("[data-city-filter-button]"));
      const applyCity = (city) => {
        buttons.forEach((button) => {
          const isActive = button.getAttribute("data-city-filter-button") === city;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-pressed", isActive ? "true" : "false");
        });

        cards.forEach((card) => {
          card.classList.toggle("is-hidden", card.getAttribute("data-city-card") !== city);
        });
      };

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          applyCity(button.getAttribute("data-city-filter-button"));
        });
      });

      applyCity("中山");
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      moveProjectPaymentBeforeFaq();
      initProjectCityFilters();
    });
  } else {
    moveProjectPaymentBeforeFaq();
    initProjectCityFilters();
  }
  window.addEventListener("load", moveProjectPaymentBeforeFaq);
  window.addEventListener("load", initProjectCityFilters);
})();
